import { createSlice } from "@reduxjs/toolkit";
import { activateDeactivateNews, activateDeactivateNewsData, addNews, addNewsData, deleteNews, fetchNews, fetchNewsData, fetchNewsTableColumnNames, updateNews, updateNewsData, deleteNewsData } from "./thunk";

const initialState = {
  news: [],
  newsData: [],
  tableColumnNames: [],
  loading: false,
  error: null
};

const NewsSlice = createSlice({
  name: "News",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch News Table Column Names
    .addCase(fetchNewsTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchNewsTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchNewsTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchNews.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchNews.fulfilled, (state, action) => {
        state.loading = false;
        state.news = action.payload;
    })
    .addCase(fetchNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addNews.pending, (state) => {
        state.error = null;
    })
    .addCase(addNews.fulfilled, (state, action) => {
        state.news.unshift(action.payload);
    })
    .addCase(addNews.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateNews.pending, (state) => {
        state.error = null;
    })
    .addCase(updateNews.fulfilled, (state, action) => {
        const index = state.news.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.news[index] = action.payload;
        }
    })
    .addCase(updateNews.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteNews.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteNews.fulfilled, (state, action) => {
        const ids = action.payload.map((item) => item.ID)
        state.news = state.news.filter(
            (item) => !ids.includes(item.ID)
        );
    })
    .addCase(deleteNews.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateNews.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateNews.fulfilled, (state, action) => {
        const index = state.news.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.news[index] = action.payload;
        }
    })
    .addCase(activateDeactivateNews.rejected, (state, action) => {
        state.error = action.payload;
    })

    // News Data
    .addCase(fetchNewsData.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchNewsData.fulfilled, (state, action) => {
        state.loading = false;
        state.newsData = action.payload;
    })
    .addCase(fetchNewsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })
    
    .addCase(addNewsData.pending, (state) => {
        state.error = null;
    })
    .addCase(addNewsData.fulfilled, (state, action) => {
        state.newsData.unshift(action.payload);
    })
    .addCase(addNewsData.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateNewsData.pending, (state) => {
        state.error = null;
    })
    .addCase(updateNewsData.fulfilled, (state, action) => {
        const index = state.newsData.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.newsData[index] = action.payload;
        }
    })
    .addCase(updateNewsData.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteNewsData.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteNewsData.fulfilled, (state, action) => {
        const ids = action.payload.map((item) => item.ID)
        state.newsData = state.newsData.filter(
            (item) => !ids.includes(item.ID)
        );
    })
    .addCase(deleteNewsData.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateNewsData.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateNewsData.fulfilled, (state, action) => {
        const index = state.newsData.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.newsData[index] = action.payload;
        }
    })
    .addCase(activateDeactivateNewsData.rejected, (state, action) => {
        state.error = action.payload;
    });
    },
});

export default NewsSlice.reducer;
